'use client';

import {track} from 'iq-tracking';

interface LoopArticleLinkProps {
  href: string;
  slug: string;
  children: React.ReactNode;
}

// Thin client wrapper so the parent RSC (loop_articles.tsx) can attach click
// tracking. Mirrors related_guide_link.tsx.
export function LoopArticleLink({href, slug, children}: LoopArticleLinkProps) {
  return (
    <a
      href={href}
      target='_blank'
      rel='noopener noreferrer'
      onClick={() =>
        void track({
          event: 'loop_article_clicked',
          action: 'click',
          component: 'module',
          content_type: 'loop_article',
          content_identifier: slug,
        })
      }
      className='text-sm py-3 border-t border-gray-100 hover:underline text-gray-700 leading-snug'>
      {children}
    </a>
  );
}
